import { Car, User, Briefcase, TrendingUp } from 'lucide-react'
import React from 'react'

interface StatCardProps {
  title: string
  value: string
  icon: React.ReactNode
  trend: string
  color: {
    bg: string
    text: string
  }
}

const StatCard = ({ title, value, icon, trend, color }: StatCardProps) => {
  return (
    <div className="bg-white rounded-xl p-5 border border-slate-200 shadow-sm relative overflow-hidden group hover:border-primary/30 transition-colors">
      <div className="flex justify-between items-start mb-4">
        <div className={`p-2 ${color.bg} ${color.text} rounded-lg`}>
          {icon}
        </div>
        <span className="flex items-center text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full">
          <TrendingUp size={12} className="mr-1" />
          {trend}
        </span>
      </div>
      
      <div>
        <p className="text-slate-500 text-sm font-medium mb-1">{title}</p>
        <h3 className="text-3xl font-bold text-slate-800">{value}</h3>
      </div>
      
      <div className="absolute -right-6 -bottom-6 text-slate-50 opacity-10 group-hover:scale-110 transition-transform">
        {React.isValidElement(icon) ? React.cloneElement(icon as React.ReactElement<any>, { size: 72 }) : icon}
      </div>
    </div>
  )
}

export default StatCard